import Fondo from "../assets/quienes.png"
import { motion } from "framer-motion";

const QuienesSomos = () => {
    return (
        <div className="w-full h-auto md:h-[75vh] grid grid-cols-1 md:grid-cols-2 md:px-36">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${Fondo})` }} 
            />
            <div className="w-full h-full flex flex-col justify-center text-left px-4 md:px-10 gap-4">
                <h1 className="font-bold text-4xl">¿Quiénes somos?</h1>
                <div className="w-36 h-1.5 bg-orange-500" />
                <p className="text-lg text-justify">
                    En <strong>Genesis</strong> estamos comprometidos contigo y con tu negocio, ofreciendo soluciones integrales en operación,
                    mantenimiento y consultoría para ayudarte a crecer con eficiencia, seguridad y calidad.
                </p>
            </div>
        </div>
    );
};
export default QuienesSomos;